import React from "react";
import Style from "./header.module.scss";
import { Link } from "react-router-dom";
import logo from "./img/logo.png";
import Config from "config";
import { Dropdown, Icon, Menu, Modal } from "antd";
import Storage from "../../../../utils/Storage";
import { useAtomValue } from "jotai";
import { loginUnifySetAtom } from "../../../../service/stores/SettingsStore";
import useStorage from "../../../../utils/useStorage";
import { LoginType } from "../../../../service/auth";

const Header = () => {
    const loginUnifySet = useAtomValue(loginUnifySetAtom);

    const [loginType] = useStorage("LoginType");
    const [teacherNo] = useStorage("teacherNo");

    function onLogout() {
        Modal.confirm({
            title: "提示",
            content: "确定要退出登录吗?",
            onOk: () => {
                Storage.clear();

                if (loginType === LoginType.Form) {
                    window.location.href = `/login`;
                } else {
                    window.location.href = `${Config.CasUrl}/auth/user/logout?client_id=${loginUnifySet.clientId}`;
                }
            }
        });
    }

    function changePwd() {
        if (loginType === LoginType.Form) {
            window.location.href = "/changepwd";
        } else {
            window.location.href = loginUnifySet.changePasswordUrl;
        }
    }

    const menu = (
        <Menu className={Style.Menu}>
            <Menu.Item>
                <button
                    type="button"
                    onClick={changePwd}
                    className={Style.MenuItem}>
                    <Icon type="setting" /> 修改密码
                </button>
            </Menu.Item>
            <Menu.Item>
                <button
                    type="button"
                    onClick={onLogout}
                    className={Style.MenuItem}>
                    <Icon type="poweroff" /> 退出登录
                </button>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className={Style.header}>
            <div className={Style.logo}>
                <Link to="/">
                    <img src={logo} alt="Dufe" />{" "}
                    <span className={Style.logoText}>{Config.Title}</span>
                </Link>
            </div>

            {/* 中间导航操作项去掉 */}
            <div className={Style.Navigation} />

            <div className={Style.toolbar}>
                <Dropdown overlay={menu}>
                    <div className={Style.Dropdown}>
                        <span className={Style.Name}>{teacherNo}</span>
                    </div>
                </Dropdown>
            </div>
        </div>
    );
};

export default Header;
